import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { match } from 'ts-pattern'

import { MonitorSquare } from '@root/features/wallet-tracker/ui/tracked-wallet-square/monitor-square'
import { TrackingWalletsTable } from '@root/features/wallet-tracker/ui/tracking-wallets-table'
import { WalletsAlertsTable } from '@root/features/wallet-tracker/ui/wallet-alerts-table'
import { PageSection, UnderlineTabs } from '@root/shared/ui-kit'

type Tab = 'tracking-wallets' | 'square' | 'alerts'
type WalletTrackerTablesProps = {}

export const WalletTrackerTables: React.FC<WalletTrackerTablesProps> = () => {
  const { t } = useTranslation()
  const [tab, setTab] = useState<Tab>('tracking-wallets')

  const renderContent = () => {
    return match(tab)
      .with('tracking-wallets', () => <TrackingWalletsTable />)
      .with('alerts', () => <WalletsAlertsTable />)
      .with('square', () => <MonitorSquare />)
      .exhaustive()
  }

  return (
    <Root>
      <Tabs value={tab} onChange={setTab}>
        <UnderlineTabs.Tab value={'tracking-wallets' satisfies Tab}>
          {t('wallet-tracker')}
        </UnderlineTabs.Tab>
        {/* <UnderlineTabs.Tab value={'square' satisfies Tab}>
          {t('wallet-tracker.monitor-square')}
        </UnderlineTabs.Tab> */}
        <UnderlineTabs.Tab value={'alerts' satisfies Tab}>
          {t('wallet-tracker.alerts')}
        </UnderlineTabs.Tab>
      </Tabs>
      <TabPanel>{renderContent()}</TabPanel>
    </Root>
  )
}

const Root = styled(PageSection)`
  min-height: 0;
  height: 100%;

  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
`

const TabPanel = styled.div`
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  & > * {
    flex: 1 1 auto;
    min-height: 0;
    min-width: 0;
  }
`

const Tabs = styled(UnderlineTabs<Tab>)`
  justify-self: start;
  padding-inline: 15px;
  height: 49px;
  place-items: end;
`
